export const URL_DATE_FORMAT = `yyyy-LL-dd'T'HHmm`;
